import { useEffect } from 'react';
import { Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import TitleFavicon from '../utils/TitleFavicon';
import MainPage from '../MainPage/MainPage';
import AdminLogin from '../Panels/AdminPanel/AdminLogin';
import RestaurantLogin from '../Panels/RestaurantPanel/RestaurantLogin';
import PrivateRoutes from './PrivateRoutes';
import RestaurantRoutes from './RestaurantRoutes';
import WinePDF from '../Panels/RestaurantPanel/PDF/WinePDF';
import MenuPDF from '../Panels/RestaurantPanel/PDF/MenuPDF';
import BeveragePDF from '../Panels/RestaurantPanel/PDF/BeveragePDF';
import AdminRoutes from './AdminRoutes';
import LandingPage from '../HomeScreens/LandingPage';
import WinePage from '../HomeScreens/WineListLanding/WinePage';
import MenuPage from '../HomeScreens/MenuListLanding/MenuPage';
import BeverageProduct from '../HomeScreens/BeverageListLanding/BeverageProduct';
import CustomerProfile from '../Panels/CustomerPanel/CustomerProfile';
import CustomerChangePassword from '../Panels/CustomerPanel/CustomerChangePassword';

// import ynejoye from '../assets/restaurant/Yne&Joy.svg'

const Home = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('Role');
  const rolewiseId = localStorage.getItem('currentRestId');

  useEffect(() => {
    const currentPath = location.pathname;

    if (role === 'admin' && currentPath === `/restaurantPanel/login`) {
      navigate('/admin/dashboard');
    }

    else if (role === 'restaurant' && currentPath === `/admin/login`) {
      navigate(`/restaurantPanel/dashboard/${rolewiseId}`);
    }

    if (role === 'customer') {
      if (currentPath === '/admin/login') {
        navigate(-1);
      } else if (currentPath === '/restaurantPanel/login') {
        navigate(-1);
      }
    }

    else if (!token) {
      if (currentPath.startsWith('/admin')) {
        navigate('/admin/login');
      } else if (currentPath.startsWith('/restaurantPanel')) {
        navigate('/restaurantPanel/login');
      }
    }
  }, [location.pathname, navigate, role, token, rolewiseId]);

  return (
    <>
      <TitleFavicon />
      <Routes>
        <Route path="/" element={<MainPage />} />
        {/* <Route path="/" element={<Navigate to="/admin/login" replace />} /> */}
        {/* <Route path="/login" element={<Login />} /> */}
        {/* <Route path="*" element={<Navigate to="/restaurant/spritz-and-co-srl" />}  */}


        {/*================================ Admin ========================*/}
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/*================================ Restaurant ========================*/}
        <Route path="/restaurantPanel" element={<Navigate to="/restaurantPanel/login" replace />} />
        <Route path="/restaurantPanel/login" element={<RestaurantLogin />} />

        <Route element={<PrivateRoutes allowedRoles={['admin', 'restaurant']} />}>
          {/* Restaurant */}
          <Route path="/restaurantPanel/:rest_name" element={<RestaurantRoutes />} />
          <Route path="/restaurantPanel/:rest_name/:rest_slug2" element={<RestaurantRoutes />} />
          <Route path="/wine_list_pdf/:wine_list_name" element={<WinePDF />} />
          <Route path="/menu_list_pdf/:menu_id" element={<MenuPDF />} />
          <Route path="/beverage_list_pdf/:beverage_id" element={<BeveragePDF />} />
        </Route>

        <Route element={<PrivateRoutes allowedRoles={['admin']} />}>
          {/* Admin */}
          <Route path="/admin/:admin_name" element={<AdminRoutes />} />
          <Route path="/admin/:admin_name/:slug2" element={<AdminRoutes />} />

          <Route path="/restaurantPanel/:rest_name" element={<RestaurantRoutes />} />
          <Route path="/restaurantPanel/:rest_name/:rest_slug2" element={<RestaurantRoutes />} />
          <Route path="/wine_list_pdf/:wine_list_name" element={<WinePDF />} />
          <Route path="/menu_list_pdf/:menu_id" element={<MenuPDF />} />
          <Route path="/beverage_list_pdf/:beverage_id" element={<BeveragePDF />} />
        </Route>

        {/* Customer Panel */}

        <Route element={<PrivateRoutes allowedRoles={['customer']} />}>
          <Route path="/restaurant/profile/:rest_name" element={<CustomerProfile />} />
          <Route path="/restaurant/changePassword/:rest_name" element={<CustomerChangePassword />} />
        </Route>

        {/* User Landing Pages */}
        <Route path="/restaurant/:rest_name" element={<LandingPage />} />
        <Route path="/restaurant/:rest_name/wine-list/:wine_name" element={<WinePage />} />
        <Route path="/restaurant/:rest_name/menu-list/:menu_id" element={<MenuPage />} />
        <Route path="/restaurant/:rest_name/beverage-list/:beverage_id" element={<BeverageProduct />} />
        {/* <Route path="/wine_list_pdf/:wine_list_name" element={<WinePDF />} /> */}
        {/* <Route path="*" element={<Navigate to="/admin/login" />} /> */}
        <Route path="*" element={<Navigate to="/" />} />
        {/* <Route path="*" element={<Navigate to="/restaurant/spritz-and-co-srl" />}  */}
      </Routes>
    </>
  );
};

export default Home;
